module.exports = __webpack_public_path__ + "coin_IOTA.png?420a88202d584f3cafba15cd9bee70c0";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/coins/coin_IOTA.png
// module id = 1117
// module chunks = 2